function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Action Icon");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Button-/-@1440px-/-With-Tailing-Icon-/-Large-/-On-S-White-",
  transform: "translate(-178.000000, -15.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "System-Icon-/-Action-Arrow-/-Horizontal",
  transform: "translate(178.000000, 15.000000)"
}, React.createElement("polygon", {
  id: "Horizontal-Arrow",
  points: "9.22183043 0 7.27616468 1.95645831 13.7512384 8.4674491 0.833333333 8.4674491 0.833333333 11.5328751 13.7510772 11.532713 7.27616468 18.0435417 9.22183043 20 19.1666667 10"
}))));

var SvgButtonLabelLight = function SvgButtonLabelLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgButtonLabelLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ButtonLabel_Light.6896dd4e.svg";
export { ForwardRef as ReactComponent };